export enum actionTypes {
    REQUEST_FORCE_UPDATE = "request_force_update",

    REQUEST_HELP_CENTER_URL = "request_help_center_url",
    RECEIVE_HELP_CENTER_URL = "receive_help_center_url",
    COMPLETE_HELP_CENTER_URL = "complete_help_center_url",

    REQUEST_OTHERS_INBOX_LIST = "request_others_inbox_list",
    RECEIVE_OTHERS_INBOX_LIST = "receive_others_inbox_list",
    COMPLETE_OTHERS_INBOX_LIST = "complete_others_inbox_list",

    SAVE_OTHER_USER_DATA = "save_other_user_data",
    REMOVE_OTHER_USER_DATA = "remove_other_user_data",

    REQUEST_SUBMIT_PROBLEM = "request_submit_problem",
    COMPLETE_SUBMIT_PROBLEM = "complete_submit_problem",

    REQUEST_SIDE_MENU_DATA = "request_side_menu_data",
    RECEIVE_SIDE_MENU_DATA = "receive_side_menu_data",
    COMPLETE_SIDE_MENU_DATA = "complete_side_menu_data",

    REQUEST_CPA_PORTAL_URL = "request_cpa_portal_url",
    RECEIVE_CPA_PORTAL_URL = "receive_cpa_portal_url",
    COMPLETE_CPA_PORTAL_URL = "complete_cpa_portal_url",
}